import React, { useEffect, useState } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { CreateProductApi } from "../../ApiRequests"; // Updated API function
import AuthBtn from "../Buttons/AuthBtn";
import { useDispatch } from "react-redux";
import { fetchProducts } from "../../store/Slices/ProductSlice";
import UnitSelector from "../Selector/UnitSelector";
import CompanySelector from "../Selector/CompanySelector";

const user = JSON.parse(localStorage.getItem("user"));

const CreateProductModal = ({ Open, setOpen }) => {
  const [ItemCode, setItemCode] = useState("");
  const [ItemName, setItemName] = useState("");
  const [ItemPurchase, setItemPurchase] = useState("");
  const [ItemSale, setItemSale] = useState("");
  const [ItemSaleShop, setItemSaleShop] = useState("");

  const [SelectedSubCategory, setSelectedSubCategory] = useState("");
  const [SelectedCategory, setSelectedCategory] = useState("");
  const [SelectedSupplier, setSelectedSupplier] = useState("");
  const [SelectedUnit, setSelectedUnit] = useState("");

  const [ProductName, setProductName] = useState("");
  const [ProductCode, setProductCode] = useState("");
  const [Quantity, setQuantity] = useState("");
  const [Price, setPrice] = useState("");
  const [Customer, setCustomer] = useState("");
  const [ML, setML] = useState("");
  const [Loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (ItemName === "") {
      WarningToast("Enter a valid Item name");
    } else if (ItemCode === "") {
      WarningToast("Enter a valid Item code");
    } else if (ItemSale === "" || isNaN(ItemSale) || ItemSale <= 0) {
      WarningToast("Enter a valid price");
    } else if (
      ItemSaleShop === "" ||
      isNaN(ItemSaleShop) ||
      ItemSaleShop <= 0
    ) {
      WarningToast("Enter a valid shop sale price");
    } else {
      try {
        const supplierNamePart = SelectedSupplier.name.split(" ")[0];

        const response = await CreateProductApi({
          code: ItemCode.toUpperCase(),
          name: `${ItemName} ${supplierNamePart}`,
          companyId: SelectedSupplier._id,
          unit: SelectedUnit,
          purchase: ItemPurchase,
          sale: ItemSale,
          sale_shop: ItemSaleShop,
          qty: 0,
          branchId: user.branchId,
        });

        if (response.data.success) {
          setOpen(false);
          SuccessToast("Item added successfully");
          if (user.role !== 1) dispatch(fetchProducts(user.branch_number));
          else dispatch(fetchProducts());
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        ErrorToast(err.response.data.error.msg);
        ErrorToast("Failed to add Item");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Add Item
        </h1>
        <div className="flex flex-col px-10 gap-4">
          <CompanySelector
            SelectedSupplier={SelectedSupplier}
            setSelectedSupplier={setSelectedSupplier}
          />
          <UnitSelector
            SelectedUnit={SelectedUnit}
            setSelectedUnit={setSelectedUnit}
          />
          <AuthInput
            label="Item Name"
            placeholder="Enter Item Name"
            Value={ItemName}
            setValue={setItemName}
          />
          <AuthInput
            label="Item Code"
            placeholder="Enter Item Code"
            Value={ItemCode}
            setValue={setItemCode}
          />
          <AuthInput
            label="Purchase"
            placeholder="Enter Purchase Amount"
            Value={ItemPurchase}
            setValue={setItemPurchase}
            type="number"
          />
          <AuthInput
            label="Sale"
            placeholder="Enter Sale"
            Value={ItemSale}
            setValue={setItemSale}
            type="number"
          />
          <AuthInput
            label="Sale Shop"
            placeholder="Enter Sale Shop"
            Value={ItemSaleShop}
            setValue={setItemSaleShop}
            type="number"
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {Loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Add Product"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default CreateProductModal;
